import React, { useState } from "react";
import classes from './BulkUploadCustomersModal.module.css';
import { BASE_URL } from "../API/Api";
import axios from 'axios';
import Swal from 'sweetalert2';

const BulkUploadCustomersModal = ({ isOpen, onClose, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [downloading, setDownloading] = useState(false);

  if (!isOpen) return null;

  const downloadTemplate = async () => {
    setDownloading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await axios.get(`${BASE_URL}/v1/download-customer-template`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/octet-stream',
        },
        responseType: 'blob',
      });

      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      // try to obtain filename from headers
      const disposition = res.headers['content-disposition'];
      let filename = 'customer_template.xlsx';
      if (disposition) {
        const match = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/);
        if (match) filename = decodeURIComponent(match[1] || match[2]);
      }
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      Swal.fire({ icon: 'error', title: 'Download Failed', text: 'Unable to download template.' });
    } finally {
      setDownloading(false);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0] || null);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      Swal.fire({ icon: 'warning', title: 'No File', text: 'Please choose a file to upload.' });
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('file', selectedFile);

      const res = await axios.post(`${BASE_URL}/v1/customer/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      });

      Swal.fire({ icon: 'success', title: 'Upload Successful', text: res.data?.message || 'Customers uploaded.' });

      if (onSuccess) {
        onSuccess(res.data?.data || res.data);
      }

      onClose();
    } catch (error) {
      console.error('Upload error', error?.response || error);
      const msg = error.response?.data?.message || 'Upload failed. Please check the file and try again.';
      Swal.fire({ icon: 'error', title: 'Upload Failed', text: Array.isArray(msg) ? msg.join('\n') : msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={classes.modalBackdrop}>
      <div className={classes.modal}>
        <h2>Upload Members (Bulk)</h2>

        <div className={classes.content}>
          <p>Download the template, fill in member details, then upload the completed file.</p>

          <div className={classes.row}>
            <button className={classes.btnss} onClick={downloadTemplate} disabled={downloading}>
              {downloading ? (
                <>
                  <span className={classes.spinner} /> Downloading...
                </>
              ) : (
                'Download Template'
              )}
            </button>
          </div>

          <div className={classes.row}>
            <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} />
          </div>

          <div className={classes.modalActions}>
            <button className={classes.btnss} onClick={handleUpload} disabled={submitting}>{submitting ? 'Uploading...' : 'Upload'}</button>
            <button className={classes.btnssWhite} onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadCustomersModal;
